<template>
  <v-dialog v-model="visible" width="500" @keydown.esc="visible = false">
    <v-card>
      <v-card-title>
        <div class="headline">Leaving {{ title }}</div>
        <v-spacer></v-spacer>
        <v-btn text icon @click="visible = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text> Any unsaved work will be lost. Are you sure you want to leave? </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="!globalLoad">
          <v-btn color="red darken-1" text @click.native="$emit('exit')">Exit</v-btn>
        </div>
        <div v-else>
          <v-btn key="loadingBtn" color="primary" text :loading="true">Loading</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  computed: {
    globalLoad() {
      return false
    }
  },
  watch: {
    value: function (value) {
      this.visible = value
    },
    visible: function (value) {
      if (!value) {
        // As this components using v-model to pass in value,
        // we have to emit back the value
        this.$emit('input', false)
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
</style>
